import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import './BackOffice/backoffice-forms.css'
import './utils/axiosConfig'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App.jsx'
import {CartProvider} from './context/CartContext'
import {SensitiveDataLockProvider} from './context/SensitiveDataLockContext'


createRoot(document.getElementById('root')).render(
  <StrictMode>
    <CartProvider>
      <SensitiveDataLockProvider>
        <App />
        <ToastContainer position="bottom-right" autoClose={5000} />
      </SensitiveDataLockProvider>
    </CartProvider>
  </StrictMode>,
)
